import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=47ce9fe3&scoped=true"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"
import style0 from "./Device.vue?vue&type=style&index=0&id=47ce9fe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce9fe3",
  null
  
)

export default component.exports